/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * Template API
 * Something something. <br><br>The spec is available at <a href='/swagger/api.json'>/swagger/api.json</a>.
 * OpenAPI spec version: 0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ApiAppError,
  CreateDepartmentRequest,
  CreateDepartmentResponse,
  GetDepartmentResponse,
  GetDepartmentsOptionallyfilteredbylocationParams,
  GetDepartmentsResponse,
  UpdateDepartmentRequest,
  UpdateDepartmentResponse
} from './schemas'
import { getApi } from '../client';
import type { ErrorType, BodyType } from '../client';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Create Department
 */
export const createDepartment = (
    createDepartmentRequest: BodyType<CreateDepartmentRequest>,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<CreateDepartmentResponse>(
      {url: `/department`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDepartmentRequest, signal
    },
      options);
    }
  


export const getCreateDepartmentMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: BodyType<CreateDepartmentRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: BodyType<CreateDepartmentRequest>}, TContext> => {
    
const mutationKey = ['createDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDepartment>>, {data: BodyType<CreateDepartmentRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createDepartment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof createDepartment>>>
    export type CreateDepartmentMutationBody = BodyType<CreateDepartmentRequest>
    export type CreateDepartmentMutationError = ErrorType<ApiAppError>

    /**
 * @summary Create Department
 */
export const useCreateDepartment = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: BodyType<CreateDepartmentRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof createDepartment>>,
        TError,
        {data: BodyType<CreateDepartmentRequest>},
        TContext
      > => {

      const mutationOptions = getCreateDepartmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete Department
 */
export const deleteDepartment = (
    id: string,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<void>(
      {url: `/department/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteDepartmentMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDepartment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteDepartment(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDepartment>>>
    
    export type DeleteDepartmentMutationError = ErrorType<ApiAppError>

    /**
 * @summary Delete Department
 */
export const useDeleteDepartment = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteDepartment>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteDepartmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Department
 */
export const getDepartment = (
    id: string,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetDepartmentResponse>(
      {url: `/department/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDepartmentQueryKey = (id: string,) => {
    return [`/department/${id}`] as const;
    }

    
export const getGetDepartmentQueryOptions = <TData = Awaited<ReturnType<typeof getDepartment>>, TError = ErrorType<ApiAppError>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartment>>> = ({ signal }) => getDepartment(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDepartmentQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartment>>>
export type GetDepartmentQueryError = ErrorType<ApiAppError>


export function useGetDepartment<TData = Awaited<ReturnType<typeof getDepartment>>, TError = ErrorType<ApiAppError>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartment>>,
          TError,
          Awaited<ReturnType<typeof getDepartment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartment<TData = Awaited<ReturnType<typeof getDepartment>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartment>>,
          TError,
          Awaited<ReturnType<typeof getDepartment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartment<TData = Awaited<ReturnType<typeof getDepartment>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Department
 */

export function useGetDepartment<TData = Awaited<ReturnType<typeof getDepartment>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDepartmentQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Department
 */
export const prefetchGetDepartment = async <TData = Awaited<ReturnType<typeof getDepartment>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient, id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetDepartmentQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * @summary Update Department
 */
export const updateDepartment = (
    id: string,
    updateDepartmentRequest: BodyType<UpdateDepartmentRequest>,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<UpdateDepartmentResponse>(
      {url: `/department/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDepartmentRequest
    },
      options);
    }
  


export const getUpdateDepartmentMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{id: string;data: BodyType<UpdateDepartmentRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{id: string;data: BodyType<UpdateDepartmentRequest>}, TContext> => {
    
const mutationKey = ['updateDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDepartment>>, {id: string;data: BodyType<UpdateDepartmentRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDepartment(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateDepartment>>>
    export type UpdateDepartmentMutationBody = BodyType<UpdateDepartmentRequest>
    export type UpdateDepartmentMutationError = ErrorType<ApiAppError>

    /**
 * @summary Update Department
 */
export const useUpdateDepartment = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{id: string;data: BodyType<UpdateDepartmentRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateDepartment>>,
        TError,
        {id: string;data: BodyType<UpdateDepartmentRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateDepartmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Departments (optionally filtered by location)
 */
export const getDepartmentsOptionallyfilteredbylocation = (
    params?: GetDepartmentsOptionallyfilteredbylocationParams,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetDepartmentsResponse>(
      {url: `/departments`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetDepartmentsOptionallyfilteredbylocationQueryKey = (params?: GetDepartmentsOptionallyfilteredbylocationParams,) => {
    return [`/departments`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDepartmentsOptionallyfilteredbylocationQueryOptions = <TData = Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>, TError = ErrorType<ApiAppError>>(params?: GetDepartmentsOptionallyfilteredbylocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentsOptionallyfilteredbylocationQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>> = ({ signal }) => getDepartmentsOptionallyfilteredbylocation(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDepartmentsOptionallyfilteredbylocationQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>>
export type GetDepartmentsOptionallyfilteredbylocationQueryError = ErrorType<ApiAppError>


export function useGetDepartmentsOptionallyfilteredbylocation<TData = Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>, TError = ErrorType<ApiAppError>>(
 params: undefined |  GetDepartmentsOptionallyfilteredbylocationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentsOptionallyfilteredbylocation<TData = Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>, TError = ErrorType<ApiAppError>>(
 params?: GetDepartmentsOptionallyfilteredbylocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentsOptionallyfilteredbylocation<TData = Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>, TError = ErrorType<ApiAppError>>(
 params?: GetDepartmentsOptionallyfilteredbylocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Departments (optionally filtered by location)
 */

export function useGetDepartmentsOptionallyfilteredbylocation<TData = Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>, TError = ErrorType<ApiAppError>>(
 params?: GetDepartmentsOptionallyfilteredbylocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDepartmentsOptionallyfilteredbylocationQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Departments (optionally filtered by location)
 */
export const prefetchGetDepartmentsOptionallyfilteredbylocation = async <TData = Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient, params?: GetDepartmentsOptionallyfilteredbylocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentsOptionallyfilteredbylocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetDepartmentsOptionallyfilteredbylocationQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


